import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { cn, getUserDetails } from '../../../../utils';
import { hasOnlyChatNotification } from '../../../../utils/chatUtils';
import useMobileDetect from '../../../hooks/useMobileDetect';
import useScrollDirection from '../../../hooks/useScrollDirection';
import Logo from '../../Common/Logo';
import RedDot from '../../Common/RedDot';
import { Skeleton } from '../../Common/Skeleton';
import { MdNotificationsNone } from '../../CustomSVG/MaterialIcons';
import SelectCity from '../../SelectCity/SelectCity';
import CategorySubNavbar from '../CategorySubNavbar/CategorySubNavbar';
import LoginButton from '../LoginButton';
import SubNavBar from '../SubNavBar/SubNavBar';
import LoggedInUserPanel from './LoggedInUserPanel';
import LoveFilterTopNav from './LoveFilterTopNav';

function Filler({ hideCategorybar, scrollDirection }) {
  const router = useRouter();
  return (
    <div
      className={cn(
        scrollDirection === 'down' && 'md:h-[100px]',
        scrollDirection === 'up' &&
          hideCategorybar &&
          router.pathname !== '/dashboard' &&
          'h-[138px] md:h-[155px]',
        scrollDirection === 'up' &&
          !hideCategorybar &&
          router.pathname !== '/dashboard' &&
          router.pathname !== '/rons-tips/newsletter-preview/[id]' &&
          'h-[194px] md:h-[207px]'
      )}
    />
  );
}

const TopNav = ({ isAuthenticated, setOpenNotificationMenu }) => {
  const isMobile = useMobileDetect();
  const { scrollDirection } = useScrollDirection();
  const router = useRouter();
  const isListicleDetailsPage = router.asPath.includes('#listicleItem');
  const { categoryId } = router?.query;

  const [checkAuthenticationIsInProgress, setCheckAuthenticationIsInProgress] =
    useState(true);

  const loveProfile = useSelector(({ love }) => love?.isCurrentUserRegistered);

  const isLove =
    router.pathname.includes('/community/categories') && categoryId == 15;

  const isNotificationsPage = router.pathname === '/notifications';

  const unreadNotifications = useSelector(
    ({ notifications }) => notifications?.unreadNotifications
  );

  const hideCategorybar =
    router.pathname.includes('/dashboard') ||
    router.pathname.includes('/my-follows') ||
    router.pathname.includes('/my-favorites') ||
    router.pathname.includes('/account-settings') ||
    router.pathname.includes('/profile') ||
    router.pathname.includes('/advertise-on-ron-orp') ||
    router.pathname.includes('/top-placement') ||
    router.pathname.includes('/advertise-on-ron-orp') ||
    router.pathname.includes('/advertise-on-ron-orp') ||
    router.pathname.includes('/checkout') ||
    router.pathname.includes('/chats') ||
    router.pathname.includes('/community/tags') ||
    router.pathname.includes('/payment') ||
    router.pathname.includes('/apply-as-a-city-writer') ||
    router.pathname.includes('/market/my-paid-ads');

  function shouldHideTopNav() {
    if (
      scrollDirection === 'down' &&
      router.pathname !== '/dashboard' &&
      !isListicleDetailsPage
    ) {
      return true;
    }
    return false;
  }

  function checkAuthentication() {
    const userDetails = getUserDetails();
    if (userDetails?.user_id) {
      setCheckAuthenticationIsInProgress(false);
    } else {
      setCheckAuthenticationIsInProgress(false);
    }
  }

  useEffect(() => {
    checkAuthentication();
  }, []);

  return (
    <>
      <div
        id='top-nav'
        className={cn(
          'z-[99] w-full bg-white transition-all duration-500 md:block',
          shouldHideTopNav()
            ? 'fixed top-[-220px]'
            : router.pathname === '/dashboard' || isListicleDetailsPage
              ? 'sticky top-0'
              : 'fixed top-0'
        )}
      >
        <div className='border-b border-border-mid bg-white'>
          <div className='custom-container flex flex-row-reverse items-center justify-between py-[16px] md:flex-row'>
            <div className='flex items-center gap-[12px]'>
              {isMobile && (
                <div
                  onClick={() => {
                    if (!isNotificationsPage) {
                      setOpenNotificationMenu(true);
                    }
                  }}
                  className='relative h-[24px] w-[24px]'
                >
                  <MdNotificationsNone className='h-[24px] w-[24px]' />
                  {unreadNotifications &&
                    unreadNotifications?.length > 0 &&
                    !hasOnlyChatNotification(unreadNotifications) && <RedDot />}
                </div>
              )}
              <SelectCity />
            </div>

            <Logo />
            <div className='hidden md:block'>
              {isAuthenticated ? (
                <LoggedInUserPanel />
              ) : checkAuthenticationIsInProgress ? (
                <Skeleton className='h-[30px] w-[120px] rounded-[16px] border border-[#E7E7E7]' />
              ) : (
                <LoginButton />
              )}
            </div>
          </div>
        </div>
        <>
          <SubNavBar isAuthenticated={isAuthenticated} />
          {!hideCategorybar && <CategorySubNavbar />}
          {isLove && loveProfile?.user_id && <LoveFilterTopNav />}
        </>
      </div>
      <Filler
        hideCategorybar={hideCategorybar}
        scrollDirection={scrollDirection}
      />
    </>
  );
};

export default React.memo(TopNav);
